import { render } from "./OtpBanner.vue?vue&type=template&id=66e7916f"
import script from "./OtpBanner.vue?vue&type=script&lang=js"
export * from "./OtpBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__